import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { CardViewIcon, Flex, Modal, SwapVertIcon, Text, useModal } from "@pancakeswap-libs/uikit"
import styled, { ThemeContext } from 'styled-components'
import CurrencyLogo from 'components/CurrencyLogo'
import {  Currency } from '@pancakeswap-libs/sdk-v2'
import { TranslateString } from '../../utils/translateTextHelpers'
import useMatchBreakpoints from '../../hooks/useMatchBreakpoints'
import TableLpLcon from './TableLpLcon'
import { getChecksumAddress } from '../../utils/addressHelpers'
import Logo from '../../components/Logo'

const  StyleCurrencyLogo= styled(CurrencyLogo)`
  margin-right:10px !important;
`

const  PerList= styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.input};
  border-radius: 20px;
`

const  PerDex= styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.input};
  border-radius:5px ;
`
const  PerTextStyle= styled(Flex)`
  background:${({ theme }) => theme.isDark?'#494848':"#f8f0f0"} ;
  border-radius:5px ;
`
const  BorderStyle= styled(Flex)`
    border-right: 2px solid;
    border-left: 2px solid;
    max-height: 280px;
    overflow-y: auto;
    border-image:${({ theme }) => theme.isDark?'linear-gradient(transparent, rgba(200, 220, 201, 1), transparent) 5 5': 'linear-gradient(transparent,rgb(249 140 8),transparent) 5 5'}; 
`

const BodyWrapper = styled(Flex)`
  position: relative;
  max-width: 436px;
  width: 100%;
  z-index: 5;
`
const  AppBodyStyle= styled(BodyWrapper)`
    box-shadow: 0px 0px 0px 0px !important;
`
const TextStyle= styled(Text)<{isMobile?:boolean}>`
    width: ${props => props.isMobile ? "54px" : '69px'};
`
const Image = styled(Logo)<{isMobile?:boolean}>`
  height: ${props => props.isMobile ? "19px" : '26px'};
  width: ${props => props.isMobile ? "19px" : '26px'};
  display: inline-block;
  vertical-align: middle;
  position: relative;
  z-index: 2;
  vertical-align: middle;
`

const Icon = styled.svg`
  fill: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  position: relative;
  top: 2px;
`


interface RouterSwapProps {
  distribution: Array<string>;
  outputCurrency:Currency;
  inputCurrency:Currency;
}
const RouterSwap: React.FC<RouterSwapProps>=({
  distribution,
  outputCurrency,
  inputCurrency
})=>{
    const { isDesktop, isMobile } = useMatchBreakpoints();
    const logAddress="0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04";
    const tokenLog={
      'EBEN':'0x77CB87b57F54667978Eb1B199b28a0db8C8E1c0B',
      'LAW':'0x0b00366fBF7037E9d75E4A569ab27dAB84759302',
      'flexUSD':'0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72',
      'WBCH':'0x3743eC0673453E5009310C727Ba4eaF7b3a1cc04',
      "bcBCH":'0xBc9bD8DDe6C5a8e1CBE293356E02f5984693b195',
      "bcUSDT":'0xBc2F884680c95A02cea099dA2F524b366d9028Ba',
      "TANGO":'0x73BE9c8Edf5e951c9a0762EA2b1DE8c8F38B5e91',
      "MIST":'0x5fA664f69c2A4A3ec94FaC3cBf7049BD9CA73129',
      [outputCurrency?.symbol ||'']:outputCurrency?.symbol==='SBCH'?logAddress:(outputCurrency as any)?.address
    } 

    const aExchangeRoutes=[[outputCurrency?.symbol],["WBCH"],["EBEN"],["bcBCH"],["bcUSDT"],["LAW"],["flexUSD"],["TANGO"],["MIST"],["WBCH","EBEN"],["WBCH","bcBCH"],["WBCH","bcUSDT"],["WBCH","LAW"],["WBCH","flexUSD"],["WBCH","TANGO"],["WBCH","MIST"],["EBEN","WBCH"],["EBEN","bcBCH"],["EBEN","bcUSDT"],["EBEN","LAW"],["EBEN","flexUSD"],["EBEN","TANGO"],["EBEN","MIST"],["bcBCH","WBCH"],["bcBCH","EBEN"],["bcBCH","bcUSDT"],["bcBCH","LAW"],["bcBCH","flexUSD"],["bcBCH","TANGO"],["bcBCH","MIST"],["bcUSDT","WBCH"],["bcUSDT","EBEN"],["bcUSDT","bcBCH"],["bcUSDT","LAW"],["bcUSDT","flexUSD"],["bcUSDT","TANGO"],["bcUSDT","MIST"],["LAW","WBCH"],["LAW","EBEN"],["LAW","bcBCH"],["LAW","bcUSDT"],["LAW","flexUSD"],["LAW","TANGO"],["LAW","MIST"],["flexUSD","WBCH"],["flexUSD","EBEN"],["flexUSD","bcBCH"],["flexUSD","bcUSDT"],["flexUSD","LAW"],["flexUSD","TANGO"],["flexUSD","MIST"],["TANGO","WBCH"],["TANGO","EBEN"],["TANGO","bcBCH"],["TANGO","bcUSDT"],["TANGO","LAW"],["TANGO","flexUSD"],["TANGO","MIST"],["MIST","WBCH"],["MIST","EBEN"],["MIST","bcBCH"],["MIST","bcUSDT"],["MIST","LAW"],["MIST","flexUSD"],["MIST","TANGO"]]
    // 二维数组保存 路由路径 eg:[[bcbch,{}],[bcbch->law,{}]]
    const res=():Array<Array<any>>=>{
      const ret=aExchangeRoutes.map(t=>( [t.join('->'),{value:0,token: tokenLog[t.join()] || [tokenLog[(t as any)[0]],tokenLog[(t as any)[1]]]  }]));
      return ret;
    }
    const [tokenPer,setTokenPer]=useState<Array<Array<any>>>(res())
    // 交易所比咧
    const [dexList,setDexList]=useState< Array<{ name:string,value:Array<number>,total:number,}> >([
      {name:'EmberSwap',value:[],total:0},
      {name:'Verse',value:[],total:0},
      {name:'TropicalFinance',value:[],total:0},
      {name:'1BCH',value:[],total:0},
      {name:'CowSwap',value:[],total:0},
      {name:'LawSwap',value:[],total:0},
      {name:'TangoSwap',value:[],total:0},
      {name:'MistSwap',value:[],total:0},
      {name:'BenSwap',value:[],total:0}
      
    ])
 
   // init dexlist
   useEffect(()=>{
        let p=0;
        const routerNum=aExchangeRoutes.length;
        const list=dexList.map((t)=>{
          const vals=distribution.slice(p,p+routerNum);
          let total=0;
          const values:Array<number>=[];
          // eslint-disable-next-line
          for(const m of vals){
            total+=parseInt(m as any);
            values.push(parseInt(m as any));
          }
          t.total=total;
          t.value=values;
          p+=routerNum;
          return t;
        })
        // 初始化 token  比例
        const tokenPerCopy= res();
         // eslint-disable-next-line
        for(const k of list){
          tokenPerCopy.forEach((f,idx)=>{
            f[1].value+=k.value[idx];
          }) 
        }
       
   
        // 挂载dex 比例
        const keys=tokenPerCopy.map(t=>t[0])
        // const keys=Object.keys(tokenPerCopy)
        for(let i=0;i<keys.length;i++){
            const dexs=list.map(t=>({name:t.name,value:t.value[i]}));
            // dex 比例排序
            dexs.sort((a:any,b:any)=>{return b.value-a.value});
            tokenPerCopy[i][1].dex=dexs;
        } 
   
        // token 比例排序
        const sortTokenPerCopy=tokenPerCopy.sort((a:any,b:any)=>{return b[1].value-a[1].value});
        setTokenPer(sortTokenPerCopy);
        setDexList(list);
      },
      // eslint-disable-next-line
   [distribution])
  


   // card 
   const tokenCard=(dex:Array<{name:string,value:number}>)=>{
      return <Flex  flexDirection='column' >
      {
        dex.map((t)=>{
          return t.value>0?
          <PerTextStyle pl={2} pr={2} mt={1}>
            <Text fontSize={isMobile?'12px':'16px'}>{t.name}：{t.value*4}%</Text>
            </PerTextStyle>:''
        })
      }
      </Flex>
   }
 
   const addressTran=(currencyToken)=>{
     if(currencyToken?.symbol==='SBCH'){
      return logAddress
     }
     return currencyToken.address;
   }
   const RouterModal=()=>{
      return <Modal  title={TranslateString(11040,'Routing details')} >
         <AppBodyStyle>
 
         <Flex justifyContent='space-around'  alignItems='center'>
            <Flex pr={3}>
            <Image isMobile={isMobile} srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(addressTran(inputCurrency))}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={inputCurrency?.symbol} />
            </Flex>
            <BorderStyle flexDirection="column" p={3}>
              {
                tokenPer.map((t:any,idx)=>{
                 const item=t[1];
                 return (item.value>0?
                  <Flex alignItems='center'>
                    <TextStyle isMobile={isMobile} pr={1} fontSize={isMobile?'12px':'16px'}>{item.value*4}% &nbsp; &gt; &nbsp;</TextStyle>
                    <PerDex flex={1} flexDirection="column" p={3} mb={2}>
                      <Flex alignItems='center'>
                        {item.token.length===2?
                         <TableLpLcon token0={item.token[0]} token1={item.token[1]} />
                        :
                        <Image isMobile={isMobile} srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(item.token)}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={item.token} />

                         //  <StyleCurrencyLogo currency={tokenPer[t].token} size="1.2rem" />
                        }
                        <Text ml={1} fontSize={isMobile?'12px':'16px'}>{t==='0'?outputCurrency.symbol:t[0]}</Text>
                      </Flex>
                      {tokenCard(item.dex)}
                    </PerDex>
                    <Text fontSize={isMobile?'12px':'16px'}>&nbsp; &gt;</Text>
                    
                  </Flex>
                  :'')
               })
              }
                
            </BorderStyle>
            <Flex pl={3}>
              <Image isMobile={isMobile} srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(addressTran(outputCurrency))}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={outputCurrency?.symbol} />
            </Flex>
         </Flex>

         </AppBodyStyle>
         
        </Modal>
   }
   const [onPresentApyModal] = useModal(RouterModal())
   const handleClickButton = (event): void => {
     event.stopPropagation()
     onPresentApyModal()
   }

   const renderSteps= () => {
      const count = distribution.filter(t=>t!=='0').length;
      return count > 0 ? `${count} ${count>1?TranslateString(11048,'Steps'):TranslateString(11047,'Step')}` : "";
   }

   return<>
           <Flex  mb={2} justifyContent='space-between' alignItems='end'>

                <Text fontSize="14px">{TranslateString(11041,'Route') }</Text>
                <Flex>
                  <Text fontSize="14px"  mr={2}>{renderSteps()}</Text>
                  <Text fontSize="14px"><Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 384" onClick={handleClickButton} width="14px"><path d="m373.332031 0h-85.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969s4.777344 10.664062 10.667969 10.664062h59.582031l-88.457031 88.460938c-2.773438 2.675781-3.882812 6.644531-2.910156 10.371093.976562 3.730469 3.890625 6.644532 7.621094 7.621094 3.726562.972656 7.695312-.136718 10.371093-2.910156l88.460938-88.457031v59.582031c0 5.890625 4.773437 10.667969 10.664062 10.667969s10.667969-4.777344 10.667969-10.667969v-85.332031c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0"/><path d="m109.792969 259.125-88.460938 88.457031v-59.582031c0-5.890625-4.773437-10.667969-10.664062-10.667969s-10.667969 4.777344-10.667969 10.667969v85.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969h85.332031c5.890625 0 10.667969-4.777344 10.667969-10.667969s-4.777344-10.664062-10.667969-10.664062h-59.582031l88.457031-88.460938c4.042969-4.183593 3.984375-10.835937-.128906-14.953125-4.117188-4.113281-10.769532-4.171875-14.953125-.128906zm0 0"/><path d="m373.332031 277.332031c-5.890625 0-10.664062 4.777344-10.664062 10.667969v59.582031l-88.460938-88.457031c-4.183593-4.042969-10.835937-3.984375-14.953125.128906-4.113281 4.117188-4.171875 10.769532-.128906 14.953125l88.457031 88.460938h-59.582031c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h85.332031c5.890625 0 10.667969-4.777344 10.667969-10.667969v-85.332031c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0"/><path d="m36.417969 21.332031h59.582031c5.890625 0 10.667969-4.773437 10.667969-10.664062s-4.777344-10.667969-10.667969-10.667969h-85.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969v85.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.664062-4.777344 10.664062-10.667969v-59.582031l88.460938 88.457031c4.183593 4.042969 10.835937 3.984375 14.953125-.128906 4.113281-4.117188 4.171875-10.769532.128906-14.953125zm0 0"/></Icon></Text>
                </Flex>

            </Flex>
    </>
}
export default RouterSwap
